<template>
  <div class="user_page">
    <h3 class="title-page">{{ $t("requests") }}</h3>
    <div>
      <div class="admin_container">
        <div class="division_main">
          <div style="gap: 15px" class="d-flex mb-3 align-center">
            <custom-input-text
              clearable
              class="user_input no-margin"
              :placeholder="$t('productName')"
              @input="getOrdersByFilter"
              v-model="orderListFilter.productName"
              type="text"
            ></custom-input-text>
            <!--            <div class="pa-1">-->
            <!--              <custom-select-->
            <!--                clearable-->
            <!--                class="user_input no-margin"-->
            <!--                @input="getOrdersByFilter"-->
            <!--                :items="orderItemStatus"-->
            <!--                item-value="value"-->
            <!--                item-text="text"-->
            <!--                v-model="orderListFilter.positionState"-->
            <!--              ></custom-select>-->
            <!--            </div>-->
            <vue-select
              infinite
              clearable
              @item-resolved="setDepartment"
              @next-page-resolved="
                (data) => setDepartment([...departments, ...data])
              "
              :get-item-promise="
                ({ text, page }) =>
                  $store.dispatch('getDepartments', {
                    page,
                    name: text,
                    limit: 15,
                  })
              "
              :items="departments"
              v-model="orderListFilter.departmentId"
              @input="getOrdersByFilter"
              type="text"
            />
            <custom-select
              dense
              class="user_input no-margin mt-1"
              custom-selection
              custom-item
              :value="visibleHeaders"
              @input="setVisibleHeaders"
              multiple
              item-text="text"
              item-value="value"
              :items="headers"
            >
              <template #item="{ attrs, item }">
                <div
                  class="column-setting-title-wrap flex-grow-1"
                  @click="changeColumnSettings(item, attrs)"
                >
                  <base-checkbox
                    class="mr-2"
                    v-model="visibleHeaders"
                    :value="item.value"
                  />
                  <span class="v-list-item__title" style="width: 100%">{{
                    item.text
                  }}</span>
                </div>
              </template>
              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0">{{ $t("columns") }}</span>
              </template>
            </custom-select>
            <custom-date-picker
              clearable
              hide-details
              :max="new Date() || orderListFilter.toDate"
              @input="getOrdersByFilter"
              v-model="orderListFilter.fromDate"
              label=""
              name="calendar"
              color="#E3EBF3"
              class="data_item user_input data_item_calendar"
              icon="mdi-calendar-month small"
            ></custom-date-picker>
            <custom-date-picker
              :start-day="false"
              hide-details
              :min="orderListFilter.fromDate"
              :max="new Date()"
              clearable
              @input="getOrdersByFilter"
              v-model="orderListFilter.toDate"
              name="calendar_t"
              color="#E3EBF3"
              class="data_input_tw user_input data_item"
              icon="mdi-calendar-month small"
            ></custom-date-picker>
          </div>

          <!--            <div class="d-flex flex-wrap align-center">-->
          <!--              <div class="info-wrap">-->
          <!--                <div class="info-wrap-status">-->
          <!--                  <div class="info-wrap-status-box success"></div>-->
          <!--                  <span class="info-wrap-status-txt">{{-->
          <!--                    $t("orderItemStateOmtk.available")-->
          <!--                  }}</span>-->
          <!--                </div>-->
          <!--              </div>-->
          <!--              <div class="info-wrap">-->
          <!--                <div class="info-wrap-status">-->
          <!--                  <div class="info-wrap-status-box warning"></div>-->
          <!--                  <span class="info-wrap-status-txt">{{-->
          <!--                    $t("orderItemStateOmtk.notEnough")-->
          <!--                  }}</span>-->
          <!--                </div>-->
          <!--              </div>-->
          <!--              <div class="info-wrap">-->
          <!--                <div class="info-wrap-status">-->
          <!--                  <div class="info-wrap-status-box error"></div>-->
          <!--                  <span class="info-wrap-status-txt">{{-->
          <!--                    $t("orderItemStateOmtk.noAvailable")-->
          <!--                  }}</span>-->
          <!--                </div>-->
          <!--              </div>-->
          <!--              <v-btn-->
          <!--                @click="-->
          <!--                  $refs.omtkOrderItemActFilesDialog.open(selectedOrderItems)-->
          <!--                "-->
          <!--                color="primary"-->
          <!--                :disabled="!selectedOrderItems.length"-->
          <!--                >{{ $t("acts") }}-->
          <!--              </v-btn>-->
          <!--            </div>-->
        </div>

        <div class="justify-end d-flex"></div>
        <div
          id="custom__table"
          class="table_cover mobile_simple"
          style="overflow: auto"
        >
          <table-with-filter
            isEnabledResizeTable
            is-enabled-orderable-table
            @change-header-order="onChangeHeaderOrder"
            @table-header-resized="onChangeSizeHeader"
            :headers="filterableHeadersTable"
            :items.sync="orders"
            :open.sync="openedRowKey"
            :options="tableOptions"
            child-key="items"
            fixed-header
            handlerValue="numb"
            item-key="id"
            @onException="(e) => setResponseError({ error: e })"
            @update:sort="getOrdersBySort"
            :page="tableOptions.page"
          >
            <template #header.rejectionReason="{ header }">
              <span class="w-110 d-inline-block">{{ header.text }}</span>
            </template>
            <template #child.productTypeName="{ child }"
              >{{ child[`product_type_${$i18n.locale}`] }}
            </template>
            <template
              #child.contractNumber="{
                /**
                 * @type Object
                 * @property {string} contractFileName
                 */
                child,
              }"
            >
              {{ child.contractNumber }}
              <!--              <downloader-->
              <!--                v-if="child['contractLink']"-->
              <!--                :address="child['contractLink']"-->
              <!--                :file-name="child.contractFileName"-->
              <!--              >-->
              <!--                <template #default="{ downloadFile }">-->
              <!--                  <a-->
              <!--                    class="text-decoration-underline"-->
              <!--                    @click.prevent="downloadFile"-->
              <!--                    >{{ child.contractNumber }}</a-->
              <!--                  >-->
              <!--                </template>-->
              <!--              </downloader>-->
            </template>
            <template
              #child.rejectionReason="{
                /**
                 * @type Object
                 * @property {string} rejectionFileName
                 * @property {string} rejectionReason
                 */
                child,
              }"
            >
              <!--              v-if="child['rejectedSource']"-->

              <downloader
                v-if="child['rejectedSource']"
                :address="child['rejectedSource']"
                :file-name="child.rejectionFileName"
              >
                <template #default="{ downloadFile }">
                  <a
                    class="text-decoration-underline"
                    @click.prevent="downloadFile"
                    >{{ child.rejectionReason }}</a
                  >
                </template>
              </downloader>
            </template>
            <template #expandBtn="{ item, handlerValue, openHandler }">
              <triangle-btn
                :active="item.show"
                :loading="item.loading"
                @click="
                  () => {
                    openHandler(item);
                    $toggleShowHandler(item.id, item.show);
                  }
                "
              />
            </template>
            <template #item.action="{ item, index }">
              <v-btn
                class="new_style"
                @click="$refs.orderDialogView.open({ item })"
                :data-test="`omtkOrders-order-${index}-eye-btn`"
              >
                <vue-icon icon="newEyeIcon"></vue-icon>
              </v-btn>
              <v-btn
                @click="$refs.orderHistoryDialog.open(item.id)"
                class="new_style"
                :title="$tc('orderHistory', 1)"
                :data-test="`omtkOrders-order-${index}-reindex-btn`"
              >
                <vue-icon icon="newTimeIcon"></vue-icon>
              </v-btn>
              <v-tooltip
                v-if="$store.getters.isUserAdmin"
                color="#fff"
                left
                nudge-right="10"
                nudge-top="35"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="new_style"
                    @click="$refs.deleteProductRef.open(item)"
                    :data-test="`omtkOrders-order-${index}-delete-btn`"
                  >
                    <vue-icon icon="newTrashIcon" />
                  </v-btn>
                </template>
                <span>{{ $t("delete") }}</span>
              </v-tooltip>
              <downloader
                v-if="item['attachmentLink']"
                :address="item['attachmentLink']"
                :file-name="item['attachmentFileName']"
              >
              </downloader>
              <!--                <v-tooltip color="#fff" left nudge-right="10" nudge-top="35">-->
              <!--                  <template v-slot:activator="{ on, attrs }">-->
              <!--                    <v-btn-->
              <!--                      v-bind="attrs"-->
              <!--                      v-on="on"-->
              <!--                      class="btn_33 edit_btn"-->
              <!--                      @click="downloadOrderFile(item.numb)"-->
              <!--                      :data-test="`omtkOrders-order-${index}-download-btn`"-->
              <!--                    >-->
              <!--                      <v-icon icon="mdiTrayArrowDown"-->
              <!--                        >mdi-tray-arrow-down</v-icon-->
              <!--                      >-->
              <!--                    </v-btn>-->
              <!--                  </template>-->
              <!--                  <span>{{ $t("downloadFile") }}</span>-->
              <!--                </v-tooltip>-->
            </template>
            <template #item.state="{ item }">
              <span
                :style="{ color: item.statusColour }"
                class="font-weight-bold"
                >{{ $t(item.statusCode) }}</span
              >
            </template>
            <template #item.sendDate="{ item }">
              {{ item["sendDate"] | fullTimeParse }}
            </template>
            <template #item.numb="{ item }">
              <span v-if="!item.parent_id" class="font-weight-bold">{{
                item["numb"]
              }}</span>
            </template>
            <template
              #item.numberRequestOrderItem="{
                index,
                /**
                 *  @type Object
                 *  @property {string} parent_id
                 */
                item,
                child,
              }"
            >
              <span v-if="item.parent_id">{{ child["numb"] }}</span>
            </template>
            <template
              #child.productName="{ child: { productName, MSDSFileName } }"
            >
              <downloader
                v-if="MSDSFileName"
                :address="MSDSFileName"
                :file-name="MSDSFileName"
              >
                <template #default="{ downloadFile }">
                  <a
                    class="text-decoration-underline"
                    @click.prevent="downloadFile"
                    >{{ productName }}</a
                  >
                </template>
              </downloader>
            </template>
            <template #child.acts="{ child, item }">
              <div class="d-flex" v-if="child.contractNumber">
                <v-checkbox
                  dense
                  multiple
                  v-model="selectedOrderItems"
                  :value="`${item.numb}:${child.itemNumb}:${child.id}`"
                  class="mt-0"
                  hide-details
                ></v-checkbox>
                <v-btn
                  class="new_style"
                  @click="$refs.orderItemActFilesDialog.open(child.id)"
                >
                  <vue-icon icon="newFileEdit"></vue-icon>
                </v-btn>
              </div>
            </template>
            <template #child.action="{ itemIndex, index, child, item }">
              <order-table-child-action
                @FINISH_ORDER_ITEM="$refs.finishOrderItemDialog.open($event)"
                @openReception="
                  (id) =>
                    $refs.omtkReceptionDialogList.open({
                      id,
                      orderItemIndex: index - 1,
                      orderIndex: itemIndex,
                    })
                "
                :child="child"
                :item="item"
                :itemIndex="itemIndex"
                :index="index"
                :product-enough="
                  getChildStatusInfo(child).className === 'round_green'
                "
                @acceptOrderItem="acceptOrderItem(child)"
                @editItem="editItem(child)"
                @rejectOrderConfirmHandler="rejectOrderConfirmHandler(child)"
                @sendOrder="sendOrder(child)"
              />
            </template>
            <template
              #child.guessReceiveDate="{
                /**
                 * @type Object
                 * @property {string} itemGuessReceiveDate
                 */
                child,
              }"
              >{{ child.itemGuessReceiveDate | fullTimeParse }}</template
            >
            <template #child.state="{ child }">
              <span
                :style="{ color: child.statusColour }"
                class="font-weight-bold no-wrap-text"
                >{{ $t(child.state) }}</span
              >
            </template>
            <template #child.numb="{ item, child }">
              <v-tooltip
                v-if="child.state === TO_REVIEW_WAREHOUSE"
                color="#fff"
                left
                nudge-right="50"
                nudge-top="35"
              >
                <template #activator="{ on, attrs }">
                  <div
                    v-bind="attrs"
                    v-on="on"
                    class="d-flex"
                    style="
                      position: absolute;
                      top: 0;
                      left: 0;
                      width: 100%;
                      height: 100%;
                    "
                  >
                    <div
                      :class="getChildStatusInfo(child).className"
                      class="round_status"
                    ></div>
                  </div>
                </template>
                {{ getChildStatusInfo(child).description }}
              </v-tooltip>
            </template>
            <template #child.hasProductCount="{ child }">{{
              child.hasProductCount | numberParse
            }}</template>
            <template
              #child.count="{
                /**
                 * @type Object
                 * @property {number} given
                 */
                child,
              }"
            >
              <div
                :class="child.statusLimit"
                class="d-flex align-center justify-center"
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                "
              ></div>
              <span style="z-index: 1; position: relative" class="no-wrap-text"
                >{{ child.given | numberParse }} /
                {{ child.count | numberParse }}</span
              >
            </template>
            <template #child.numberRequestOrderItem="{ child }">{{
              child["numb"]
            }}</template>
            <template #child.sendDate>
              <span></span>
            </template>
            <template #item.receiverDate><span></span></template>
            <template
              #child.receiverDate="{
                /**
                 * @type Object
                 * @property {string} actualReceiveDate
                 */
                child,
              }"
              >{{ child.actualReceiveDate | fullTimeParse }}</template
            >
            <template
              #child.productAttrs="{
                /**
                 * @type Object
                 * @property {Array<string>} productAttrs
                 */
                child,
              }"
              ><span v-if="child.productDescription">{{
                child.productDescription
              }}</span></template
            >
            <template #child.unitTypeName="{ child }">{{
              child[`unit_type_name_${$i18n.locale}`]
            }}</template>
            <template #item.timeToBeEntered="{ item: { timeToBeEntered } }">{{
              timeToBeEntered | fullTimeParse
            }}</template>
            <template #child.timeToBeEntered="{ child: { timeToBeEntered } }"
              >{{ timeToBeEntered | fullTimeParse }}
            </template>
            <template
              #child.pendingPurchaseDate="{ child: { pendingPurchaseDate } }"
            >
              {{ pendingPurchaseDate | fullTimeParse }}
            </template>
            <template #child.contractDate="{ child: { conclusionDate } }">{{
              conclusionDate | dateParse
            }}</template>
            <template
              #child.itemConclusionDate="{ child: { itemConclusionDate } }"
            >
              {{ itemConclusionDate | fullTimeParse }}
            </template>
            <template #append:child="{ item }">
              <tr v-if="item.itemsPageCount > 1">
                <td :colspan="filterableHeadersTable.length">
                  <div class="d-flex">
                    <vue-pagination
                      @input="(page) => onChangeItemPage({ page, item })"
                      :length="item.itemsPageCount"
                      v-model="item.itemsCurrentPage"
                    ></vue-pagination>
                  </div>
                </td>
              </tr>
            </template>
          </table-with-filter>
        </div>
        <vue-pagination
          v-model="tableOptions.page"
          :length="lastPage"
          @input="changePage"
          go-to
        />
      </div>
      <v-dialog
        v-model="dialogTerminate"
        class="user_modal_dialog"
        max-width="600px"
        persistent
        @click:outside="dialogTerminate = false"
      >
        <validation-observer ref="rejectObs" v-slot="{ handleSubmit }">
          <v-form @submit.prevent="handleSubmit(rejectOrderHandler)">
            <v-card>
              <v-card-title class="">
                <span class="headline title_modal_user">{{
                  $t("rejectRequest")
                }}</span>
                <v-icon
                  class="info_modal_close"
                  @click="dialogTerminate = false"
                  >mdi-close</v-icon
                >
              </v-card-title>
              <v-card-text class="main_modal">
                <v-container class="pa-0 user_modal_form">
                  <div class="mb-5">
                    <custom-input-text
                      v-model="reason.message"
                      :label="$t('requestRejectionHint')"
                      :rules="`required_custom_message:${$t(
                        'validation.required_reject'
                      )}`"
                      class="col-lg-12 pa-0 user_input"
                    ></custom-input-text>
                  </div>
                </v-container>
              </v-card-text>
              <v-card-actions class="footer_modal_user">
                <div class="row pt-6">
                  <div class="col-xs-6 pt-0 pb-0 ml-3 file_input_modal_add_ozl">
                    <validation-provider
                      v-slot="{ errors }"
                      :name="$t('file')"
                      rules="document|not_empty_file"
                    >
                      <v-file-input
                        v-model="reason.file"
                        :error-messages="errors[0]"
                        :label="$t('attachFile')"
                        :name="$t('file')"
                      ></v-file-input>
                    </validation-provider>
                  </div>
                  <div
                    class="d-flex flex-wrap justify-space-around button_modal_add mr-3 mt-3"
                  >
                    <v-btn color="#EE6565" dark type="submit">{{
                      $t("reject")
                    }}</v-btn>
                  </div>
                </div>
              </v-card-actions>
            </v-card>
          </v-form>
        </validation-observer>
      </v-dialog>
      <order-dialog-view ref="orderDialogView"></order-dialog-view>
      <CalculateDialog
        v-model="dialogCheck"
        :item="editedItem"
        @apply="calculateChild"
      ></CalculateDialog>
      <omtk-reception-dialog-list
        @change-notify="
          ({ orderIndex, orderItemIndex }) => {
            orders[orderIndex].items[orderItemIndex].seenInitiatorNotification =
              'true';
          }
        "
        ref="omtkReceptionDialogList"
      />
    </div>
    <order-history-dialog ref="orderHistoryDialog"></order-history-dialog>
    <finish-order-item-dialog
      @completed="getOrders"
      ref="finishOrderItemDialog"
    ></finish-order-item-dialog>
    <order-item-act-files-dialog
      :hasAccessUploadFile="$can($permissions.ORDER_ITEM_ATTACH_AKT_FILES)"
      ref="orderItemActFilesDialog"
    />
    <omtk-order-item-act-files-dialog
      hasAccessUploadFile
      @CLOSE="selectedOrderItems = []"
      ref="omtkOrderItemActFilesDialog"
    ></omtk-order-item-act-files-dialog>
    <warning-dialog
      v-model="warningDialog"
      @apply="deleteOrderHandler"
      ref="deleteProductRef"
    ></warning-dialog>
  </div>
</template>

<script>
const FilterOmtkOrder = {
  productName: null,
  departmentId: null,
  itemNumb: null,
  groupId: null,
  name: null,
  positionState: null,
  fromDate: null,
  toDate: null,
  supplierId: null,
};
const ITEM_LIMIT = 200;

import gridTableMixin from "@/configuration/mixins/gridTableMixin";
import triangleBtn from "@/components/table-with-children/triangleBtn";
import {
  orderItemStatus,
  userTypes,
  orderStatus,
  TABLES,
} from "@/utils/constants";
import CalculateDialog from "@/components/omtk/CalculateDialog";
import OrderTableChildAction from "@/components/omtk/OrderTableChildAction";
import {
  debounce,
  getQueryByKey,
  makerPagination,
  trueSet,
  // downloadBlobFile,
} from "@/utils/pureFunctions";
import Downloader from "@/components/ui/downloader";
import WarningDialog from "../../../components/ui/prompt/warning-dialog.vue";
import SocketService from "@/services/SocketService";
import { omtkSocketService } from "@/utils/socket/omtk";
import OmtkReceptionDialogList from "@/components/omtk/ReceptionDialogList";
import OrderItemActFilesDialog from "@/components/order/OrderItemActFilesDialog";
import OmtkOrderItemActFilesDialog from "@/components/order/OmtkOrderItemActFilesDialog.vue";
import TableWithFilter from "@/components/ui/table/TableWithFilter";
import VueSelect from "@/components/ui/vue-select/VueSelect";
import BaseCheckbox from "@/components/ui/BaseCheckbox";
import VuePagination from "@/components/ui/vue-pagination/VuePagination";
import OrderDialogView from "@/components/order-dialog-view/OrderDialogView";
import OrderHistoryDialog from "@/components/order/OrderHistoryDialog";
import FinishOrderItemDialog from "@/components/omtk/FinishOrderItemDialog.vue";

export default {
  components: {
    OmtkOrderItemActFilesDialog,
    FinishOrderItemDialog,
    WarningDialog,
    OrderHistoryDialog,
    VuePagination,
    OrderDialogView,
    BaseCheckbox,
    VueSelect,
    TableWithFilter,
    OrderItemActFilesDialog,
    OmtkReceptionDialogList,
    Downloader,
    CalculateDialog,
    triangleBtn,
    OrderTableChildAction,
  },
  data() {
    return {
      warningDialog: false,
      selectedOrderItems: [],
      productTypes: [],
      productGroups: [],
      users: [],
      departments: [],
      isShowFilter: false,
      openedRowKey: [],
      orderListFilter: {
        ...FilterOmtkOrder,
      },
      tableOptions: {
        sortBy: "sendDate",
        sortDirection: false,
        page: 1,
      },
      reason: {
        message: "",
        file: null,
      },
      form: {},
      orders: [],
      suppliers: [],
      lastPage: 0,
      dialogTerminate: false,
      dialogCheck: false,
      editedItem: null,
      ...orderItemStatus,
    };
  },
  computed: {
    filterableHeadersTable() {
      return this.headers.filter((item) => {
        return this.visibleHeaders.includes(item.value);
      });
    },
    orderStatus() {
      return Object.entries(orderStatus)
        .filter(([prop]) => {
          return orderItemStatus.NEW !== prop;
        })
        .map(([value, text]) => {
          return {
            text: this.$t(text),
            value,
          };
        });
    },
    orderItemStatus() {
      return Object.entries(orderItemStatus)
        .filter(([prop]) => {
          return orderItemStatus.NEW !== prop;
        })
        .map(([value, text]) => {
          return {
            text: this.$t(text),
            value,
          };
        });
    },
  },
  watch: {
    dialogCheck(val) {
      if (!val) {
        this.editedItem = null;
      }
    },
    dialogTerminate(val) {
      if (!val) {
        this.editedItem = null;
        this.reason = {
          message: "",
          file: null,
        };
        const { rejectObs } = this.$refs;
        if (rejectObs) rejectObs.reset();
      }
    },
  },
  methods: {
    setVisibleHeaders(headers) {
      this.visibleHeaders = headers;
    },
    setProductType(productTypes) {
      this.productTypes = productTypes;
    },
    setProductGroups(productGroups) {
      this.productGroups = productGroups;
    },
    setUser(users) {
      this.users = users;
    },
    setDepartment(departments) {
      this.departments = departments;
    },
    setSupplier(suppliers) {
      this.suppliers = suppliers;
    },
    setVisibleHeader(headers) {
      this.visibleHeaders = headers;
    },
    /**
     * @typedef Param {Object}
     * @property page {Number}
     * @property item {Object}
     * @param param {Object<Param>}
     */
    async onChangeItemPage(param) {
      const page = param.page - 1;
      this.showLoading();
      try {
        const {
          data: { data },
        } = await this.$http.get("orders/items-omtk", {
          params: {
            objectId: param.item.id,
            limit: ITEM_LIMIT,
            page,
          },
        });
        param.item.items = data.map(this.parseOrderItems);
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    async deleteOrderHandler(item) {
      this.showLoading();
      try {
        await this.$http.delete("office/orders/delete", {
          params: { id: item.id },
        });
        await this.getOrders();
      } catch (err) {
        this.setResponseError({ error: err });
      } finally {
        this.clearLoading();
      }
    },
    // async downloadOrderFile(orderNumb) {
    //   try {
    //     const { data } = await this.$http.get(`orders/${orderNumb}`, {
    //       responseType: "blob",
    //     });
    //     let blob = new Blob([data], { type: "xlsx" });
    //     downloadBlobFile(blob, `накладной-${orderNumb}.xlsx`);
    //   } catch (err) {
    //     this.setResponseError({ error: err });
    //   } finally {
    //     this.clearLoading();
    //   }
    // },
    async changeColumnSettings(item, attr) {
      try {
        await this.$store.dispatch("updateColumn", {
          columnName: item.value,
          table: TABLES["Order"].slug,
          visible: !trueSet(attr["aria-selected"]),
        });
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
    async getOrdersBySort() {
      const { query: initialQuery } = this.$route;
      await this.$router.replace({
        query: { ...initialQuery, ...this.tableOptions },
      });
      this.showLoading();
      await this.getOrders();
      this.clearLoading();
    },
    getOrdersByFilter: debounce(async function () {
      this.showLoading();
      this.tableOptions.page = 1;
      await this.getOrders();
      await this.$router
        .replace({ query: { ...this.tableOptions, ...this.orderListFilter } })
        .catch((err) => {
          console.warn(err);
        });
      this.clearLoading();
    }, 300),
    async changePage() {
      this.showLoading();
      await this.getOrders();
      await this.$router.replace({
        query: { ...this.tableOptions, ...this.orderListFilter },
      });
      this.clearLoading();
    },
    async getOrders() {
      this.selectedOrderItems = [];
      let params = {
        ...this.tableOptions,
        ...this.orderListFilter,
        page: this.tableOptions.page - 1,
        limit: 10,
      };
      try {
        const {
          data: { data: ordersData, total: orderTotal },
        } = await this.$http.get("/office/orders/list-omtk", { params });
        this.orders = ordersData.map(
          (
            /**
             * @type Object
             * @property {number} itemCount
             */
            item
          ) => {
            item.itemsPageCount = 0;
            item.itemsCurrentPage = 1;
            if (item.itemCount)
              item.itemsPageCount = makerPagination({
                limit: ITEM_LIMIT,
                total: +item.itemCount,
              }).lastPage;
            item.loading = false;
            item.show = true;
            item.items = item.items.map(this.parseOrderItems);
            return item;
          }
        );
        this.lastPage = makerPagination({
          limit: params.limit,
          total: orderTotal,
        }).lastPage;
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
    parseOrderItems(item) {
      let { productRemainingPercentToLimit } = item;
      if (
        productRemainingPercentToLimit &&
        item.state === orderItemStatus.TO_REVIEW_WAREHOUSE
      ) {
        productRemainingPercentToLimit = +productRemainingPercentToLimit;
        if (productRemainingPercentToLimit < 100) {
          item.statusLimit = "error-bg";
        } else if (productRemainingPercentToLimit < 110) {
          item.statusLimit = "warning-bg";
        }
      }
      return item;
    },
    async sendOrder(child) {
      this.showLoading();
      try {
        let params = {
          orderItemId: child.id,
          // value: parseInt(child.count),
        };
        await this.$http.post(`office/order-items/specification`, params);
        child.statusColour = "#8a2be2";
        child.state = orderItemStatus.PAPER_EXPECTED_SPECIFICATION;
        this.setSuccess({
          text: this.$t("orderSent"),
        });
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    async calculateChild(params) {
      try {
        this.showLoading();
        const formData = new FormData();
        Object.keys(params).forEach((item) => {
          formData.append(item, params[item]);
        });
        await this.$http.post(`office/order-items/opportunity`, formData);
        this.setSuccess({
          text: this.$t("orderSent"),
        });
        await this.getOrders();
        this.dialogCheck = false;
      } catch (e) {
        this.setErrors(e);
      } finally {
        this.clearLoading();
      }
    },
    async getOrderItem(order) {
      let params = {
        id: order.id,
        type: userTypes.OMTK,
        ...this.orderListFilter,
      };
      order.items = await this.$store.dispatch("getOrderItems", params);
      return Promise.resolve();
    },
    editItem(item) {
      this.editedItem = item;
      this.dialogCheck = true;
    },
    getChildStatusInfo(item) {
      let count = parseFloat(item.count);
      let hasCount = parseFloat(item.hasProductCount);
      if (hasCount && hasCount >= count) {
        return {
          className: "round_green",
          description: this.$t("hasProductInWereHouse"),
        };
      } else if (hasCount > 0) {
        return {
          className: "round_yellow",
          description: this.$t("notEnoughProduct"),
        };
      } else {
        return {
          className: "round_red",
          description: this.$t("noProduct"),
        };
      }
    },
    async acceptOrderItem(item) {
      this.showLoading();
      const data = {
        orderItemId: item.id,
        value: item.count,
      };
      try {
        await this.$http.post("order-status/accept", data);
        await this.getOrders();
        this.setSuccess({ text: this.$t("requestApproved") });
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    rejectOrderConfirmHandler(item) {
      this.editedItem = item;
      this.dialogTerminate = true;
    },
    async rejectOrderHandler() {
      this.showLoading();
      const { message, file } = this.reason;
      const formData = new FormData();
      formData.append("reasen", message);
      formData.append("orderItemId", this.editedItem.id);
      formData.append("value", this.editedItem.count);
      if (this.reason.file) {
        formData.append("file", file);
      }
      try {
        await this.$http.post("office/order-items/reject", formData);
        await this.getOrders();
        this.dialogTerminate = false;
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },

    async connectWebSocket() {
      try {
        const client = await SocketService.promiseConnect();
        client.subscribe(
          "/user/order/reply",
          (
            /**
             * @type Object
             * @property eventType {string}
             */

            data
          ) => {
            data = JSON.parse(data.body);
            if (omtkSocketService[data.eventType]) {
              omtkSocketService[data.eventType].call(this, data);
            }
          }
        );
      } catch (e) {
        console.log("ws error", e);
      }
    },
  },
  mixins: [gridTableMixin(TABLES.Order.slug)],
  async created() {
    const { query } = this.$route;
    const tableOptions = getQueryByKey(this.tableOptions, query);
    if (tableOptions.page) tableOptions.page = +tableOptions.page;
    if (tableOptions.sortDirection)
      tableOptions.sortDirection = trueSet(tableOptions.sortDirection);
    this.tableOptions = tableOptions;
    this.orderListFilter = getQueryByKey(FilterOmtkOrder, query);
    this.showLoading();
    await Promise.all([this.getColumns(), this.getOrders()]);
    this.clearLoading();

    // await this.connectWebSocket()
  },
  beforeDestroy() {
    // SocketService.disconnect()
  },
};
</script>
<style lang="scss">
#custom__table {
  .header_name_filter_table {
    background-color: #ffffff;
    border-bottom: 1px solid #dde6ef !important;
  }
  .header_filter_table {
    display: none;
  }
  .table_cover tbody tr td {
    border-bottom: 1px solid #dde6ef !important;
    border-top: 1px solid #dde6ef !important;
    border-right: 1px solid #dde6ef !important;
    border: none;
  }
}
</style>
